{
  "noClasses": "No classes assigned to you yet",
  "noUpcomingSessions": "No upcoming sessions.",
  "statusCancelled": "Cancelled",
  "sessionSummary": "{attending} attending · {notAttending} not · {absent} absent",
  "markAbsent": "Mark absent",
  "undo": "Undo",
  "attendanceUpdated": "Attendance updated"
}
